module.exports = __webpack_public_path__ + "img/plane-filter.439ddaf6.png";